/* @flow weak */
export default function camelCase(str) {
  return str.replace(/[_.-](\w|$)/g, function(_, x) {
    return x.toUpperCase();
  });
}



// WEBPACK FOOTER //
// ./src/utils/camelCase.js